export default __webpack_public_path__ + "static/char-s-sp01-zh-Hant-c93aee5f6e439196941c23389f9f7f6c.webp";